import { Link, useLocation } from "react-router-dom";
import logo from "../../images/FML.png";
import csrLogo from "../../images/CSR.jpg";
import csrbBg from "../../images/CSRB.png";
import "./Footer.css";

function scrollToTop() {
  window.scrollTo(0, 0);
}

export default function Footer() {
  const { pathname } = useLocation();
  const isSports = pathname === "/csr";

  return (
    <footer className={`footer ${isSports ? "footer--sports" : ""}`}       style={isSports ? { backgroundImage: `url(${csrbBg})`, backgroundSize: "auto 260%", backgroundPosition: "right center", backgroundRepeat: "no-repeat" } : {}}>
      {isSports && <div className="footer-sports-gradient" />}
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={isSports ? csrLogo : logo} alt={isSports ? "Clarens Sportz Revive" : "KGubetswana FM"} className="footer-logo" />
            {isSports ? (
              <p className="footer-brand-tagline">It is all about reviving Sports in the Clarens Community</p>
            ) : (
              <p className="footer-brand-tagline">
                Re Mona <span className="footer-lona">Le Lona</span>, Re Bina <span className="footer-lona">Le Lona</span>, Re Bua <span className="footer-lona">Le Lona</span>.
              </p>
            )}
            <p className="footer-contact">Contact: Kgubestwannafm@gmail.com</p>
          </div>
          <div>
            <h4 className="footer-heading footer-heading-gold">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/csr" onClick={scrollToTop}>CSR</Link></li>
              <li><Link to="/support" onClick={scrollToTop}>Support</Link></li>

            </ul>
          </div>
          <div>
            <h4 className="footer-heading footer-heading-gold">Connect</h4>
            <ul className="footer-links">
              {/*<li><a href="https://www.tiktok.com/@cuatro.bodroex" target="_blank" rel="noopener noreferrer">Tiktok</a></li>*/}
              <li><a href="https://www.tiktok.com/@csr2640" target="_blank" rel="noopener noreferrer">Tiktok</a></li>
              <li><a href="https://www.facebook.com/quattro.pudro" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://www.youtube.com/@ClarensSportzRevive2640" target="_blank" rel="noopener noreferrer">YouTube</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span className="footer-copy">&copy;2026 Kgubetswana FM</span>
          <span className="footer-credit">Created by <a href="https://fullyconnected.co.za" target="_blank" rel="noopener noreferrer" className="footer-credit-link">Fully Connected</a></span>
        </div>
      </div>
    </footer>
  );
}
